import { isEmpty } from "@swiggy-private/js-utils";
import { WidgetTypes } from "@swiggy-private/dls-react-mxn/dist/WidgetController/constants";
import { IPLWidgetControllerCards } from "@swiggy-private/dls-react-mxn/dist/WidgetController/PLWidgetController/type";
import { ICardsEntity } from "@swiggy-private/dls-react-mxn/dist/WidgetController/type";
import { IDineoutMenuHeaderProps } from "@swiggy-private/dls-react-mxn/dist/WidgetController/widgets/DineoutMenuHeader/types";
import type { ICurtainRaiserProps } from "@swiggy-private/portal-dineout-ui";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRestaurantLocation = (cards: Array<any>) => {
    if (!isEmpty(cards)) {
        const mastheadCard = cards?.find((card) => {
            if ((card?.card?.card as keyof ICardsEntity)?.["@type"] === WidgetTypes.DINEOUT_MENU_HEADER) return card;
        });

        const restaurantInfo = mastheadCard?.card.card as IDineoutMenuHeaderProps;
        const lat = restaurantInfo?.info?.locationInfo?.lat;
        const lng = restaurantInfo?.info?.locationInfo?.long;

        return { restLat: Number(lat), restLng: Number(lng) };
    }

    return { restLat: 0, restLng: 0 };
};

export const getCurtainRaiserProps = (cards: IPLWidgetControllerCards[] | undefined): ICurtainRaiserProps => {
    const defaultProps = {
        bgImage: "",
        logo: "",
        userName: "",
        restaurantName: "",
        restaurantText: "",
        restaurantTagText: "",
        aboutTitle: "",
        aboutText: "",
        ctaText: "",
        onCtaClick: () => {},
        onSwipe: () => {},
        onPageImpression: () => {},
    };
    if (!isEmpty(cards)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const mastHeaderWidget: any = cards[0].card.card;
        defaultProps.bgImage = mastHeaderWidget?.masthead?.files?.[0]?.url ?? "";
        defaultProps.logo = mastHeaderWidget?.info?.entityAttributes?.restaurantEntityAttributes?.logo?.logo ?? "";
        defaultProps.userName = mastHeaderWidget?.masthead?.preTitle ?? "";
        defaultProps.restaurantName = mastHeaderWidget?.info?.name ?? "";
        defaultProps.restaurantText = mastHeaderWidget?.masthead?.title ?? "";
        defaultProps.restaurantTagText = mastHeaderWidget?.masthead?.subTitle ?? "";
        defaultProps.aboutText = mastHeaderWidget?.masthead?.description ?? "";
    }

    return defaultProps;
};
